import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { TbHeartSearch } from "react-icons/tb";
import { RxDashboard, RxPinLeft } from "react-icons/rx";
import { LuFolderHeart } from "react-icons/lu";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { RiSettings5Line } from "react-icons/ri";
import { FaUsers, FaProjectDiagram, FaBullhorn, FaComments, FaChartBar } from "react-icons/fa";
import { useUser } from "../contextProviders/userContext";

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useUser();

  const isLinkActive = (path) => location.pathname === path;

  const NavLink = ({ to, icon: Icon, children }) => {
    const active = isLinkActive(to);
    return (
      <Nav.Link
        as={Link}
        to={to}
        style={{
          textAlign: "left",
          display: "flex",
          alignItems: "center",
          gap: "0.75rem",
          padding: "0.6rem 1rem",
          borderRadius: "var(--radius-md)",
          fontWeight: active ? 600 : 500,
          fontSize: "0.92rem",
          color: active ? "#fff" : "var(--color-text-secondary)",
          backgroundColor: active ? "var(--color-primary)" : "transparent",
          transition: "all var(--transition)",
          textDecoration: "none",
        }}
        onMouseEnter={(e) => {
          if (!active) {
            e.currentTarget.style.backgroundColor = "rgba(27,58,135,0.07)";
            e.currentTarget.style.color = "var(--color-primary)";
          }
        }}
        onMouseLeave={(e) => {
          if (!active) {
            e.currentTarget.style.backgroundColor = "transparent";
            e.currentTarget.style.color = "var(--color-text-secondary)";
          }
        }}
      >
        <Icon size={20} style={{ flexShrink: 0 }} />
        <span>{children}</span>
      </Nav.Link>
    );
  };

  const handleLogout = async () => {
    await logout();
    navigate("/signin");
  };

  return (
    <Navbar
      expand="lg"
      variant="light"
      className="flex-column d-none d-lg-flex align-self-start"
      style={{
        width: "17rem",
        height: "100vh",
        position: "sticky",
        top: 0,
        alignSelf: "flex-start",
        flexShrink: 0,
        zIndex: 1020,
        backgroundColor: "var(--color-surface)",
        borderRight: "1px solid var(--color-border)",
        boxShadow: "var(--shadow-sm)",
        overflowY: "auto",
        padding: "0",
      }}
    >
      {/* ── Logo Block ── */}
      <div
        style={{
          padding: "1.25rem 1.5rem 1rem",
          borderBottom: "1px solid var(--color-border)",
          width: "100%",
        }}
      >
        <Navbar.Brand as={Link} to="/dashboard" style={{ margin: 0, padding: 0 }}>
          <img
            src="newlogo1.jpg"
            alt="CSD Logo"
            style={{
              maxHeight: "90px",
              width: "auto",
              objectFit: "contain",
            }}
          />
        </Navbar.Brand>
      </div>

      {/* ── Nav Links ── */}
      <Navbar.Collapse id="sidebar-nav" className="d-lg-block w-100" style={{ flex: 1 }}>
        <div className="d-flex flex-column h-100" style={{ padding: "1rem 0.75rem" }}>

          {/* Main Menu */}
          <div
            style={{
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "var(--color-text-muted)",
              paddingLeft: "1rem",
              marginBottom: "0.5rem",
              marginTop: "0.25rem",
            }}
          >
            Main Menu
          </div>

          <Nav className="flex-column gap-1 mb-3">
            {user && user.role === "admin" ? (
              <>
                <NavLink to="/admin/dashboard" icon={RxDashboard}>Admin Dashboard</NavLink>
                <NavLink to="/admin/projects"  icon={FaProjectDiagram}>Projects</NavLink>
                <NavLink to="/admin/students"  icon={FaUsers}>Students</NavLink>
                <NavLink to="/admin/reports" icon={FaChartBar}>Reports & Exports</NavLink>
                <NavLink to="/admin/announcements" icon={FaBullhorn}>Announcements</NavLink>
                <NavLink to="/messages"        icon={FaComments}>Direct Messages</NavLink>
              </>
            ) : (
              <>
                <NavLink to="/dashboard"      icon={RxDashboard}>Dashboard</NavLink>
                <NavLink to="/myprojects"     icon={LuFolderHeart}>My Projects</NavLink>
                <NavLink to="/browse"         icon={TbHeartSearch}>Browse</NavLink>
                <NavLink to="/announcements"  icon={FaBullhorn}>Announcements</NavLink>
                <NavLink to="/messages"       icon={FaComments}>Direct Messages</NavLink>
              </>
            )}
          </Nav>

          {/* Others */}
          <div
            style={{
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "var(--color-text-muted)",
              paddingLeft: "1rem",
              marginBottom: "0.5rem",
            }}
          >
            Others
          </div>

          <Nav className="flex-column gap-1">
            <NavLink to="/settings" icon={RiSettings5Line}>Settings</NavLink>
            <NavLink to="/help"     icon={IoMdHelpCircleOutline}>Tech Support</NavLink>
          </Nav>
        </div>
      </Navbar.Collapse>

      {/* ── Logout ── */}
      <div
        style={{
          borderTop: "1px solid var(--color-border)",
          width: "100%",
          padding: "1rem 1.5rem",
        }}
      >
        <div
          onClick={handleLogout}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.75rem",
            cursor: "pointer",
            color: "var(--color-red)",
            fontWeight: 600,
            fontSize: "0.92rem",
            padding: "0.5rem 0.5rem",
            borderRadius: "var(--radius-md)",
            transition: "background var(--transition)",
          }}
          onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(193,57,43,0.07)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
        >
          <RxPinLeft size={20} />
          <span>Logout</span>
        </div>
      </div>
    </Navbar>
  );
}

export default Sidebar;
